import axios from "axios";
import React, { useContext } from "react";
import { Endpoints } from "../API/Endpoints";
import { ThemeContext } from "../Contexts/Theme";
import { UserContext } from "../Contexts/User";
import api from "../Services/api";
import { createHeaders, loadItem } from "../Utils";
import { useValidateErrorResponse } from "./useValidateErrorResponse";

const { CancelToken } = axios;

export const useRecoveryPassword = () => {
  const { validateError } = useValidateErrorResponse();
  const [requestLoading, setRequestLoading] = React.useState(false);
  const [requestError, setRequestError] = React.useState(false);
  const [requestData, setRequestData] = React.useState({ status: false });

  const fetchRecoveryPassword = ({ username }) => {
    return new Promise((resolve, reject) => {
      if (!requestLoading && username) {
        setRequestError(false);
        setRequestLoading(true);
        const axiosToken = CancelToken.source();
        const cancelToken = axiosToken?.token;

        const body = {
          email: username,
        };

        api
          .put(Endpoints.PUT.reset_password, body, { cancelToken })
          .then(() => {
            setRequestData({ status: true });
            resolve();
          })
          .catch((err) => {
            setRequestError(true);
            const errMessage = validateError(err?.response?.data);
            reject(errMessage);
          })
          .finally(() => setRequestLoading(false));
      } else {
        reject();
      }
    });
  };

  return { requestData, requestError, requestLoading, fetchRecoveryPassword };
};

export const useChangePassword = () => {
  const { validateError } = useValidateErrorResponse();
  const [requestLoading, setRequestLoading] = React.useState(false);
  const [requestError, setRequestError] = React.useState(false);
  const [requestData, setRequestData] = React.useState({ status: false });

  const fetchChangePassword = ({ password, token }) => {
    return new Promise((resolve, reject) => {
      if (!requestLoading && password && token) {
        setRequestError(false);
        setRequestLoading(true);
        const axiosToken = CancelToken.source();
        const cancelToken = axiosToken?.token;

        const body = {
          password,
          token,
        };

        api
          .put(Endpoints.PUT.new_password, body, {
            cancelToken,
          })
          .then(() => {
            setRequestData({ status: true });
            resolve();
          })
          .catch((err) => {
            setRequestError(true);
            const errMessage = validateError(err?.response?.data);
            reject(errMessage);
          })
          .finally(() => setRequestLoading(false));
      } else {
        reject();
      }
    });
  };

  return { requestData, requestError, requestLoading, fetchChangePassword };
};

export const useLogout = () => {
  const [stateAuthContext, dispatchAuthContext] = useContext(AuthContext);
  const [, dispatchUserContext] = useContext(UserContext);
  const [, dispatchThemeContext] = useContext(ThemeContext);

  const [requestLoading, setRequestLoading] = React.useState(false);

  const fetchLogout = () => {
    if (stateAuthContext.tokenApp) {
      return new Promise((resolve, reject) => {
        if (!requestLoading) {
          setRequestLoading(true);
          const token = loadItem("token");
          const headers = createHeaders();

          const body = {
            token,
          };

          api.put(Endpoints.PUT.logout, body, { headers }).finally(() => {
            dispatchAuthContext({ type: "clear" });
            dispatchUserContext({ type: "clear" });
            dispatchThemeContext({ type: "clear" });
            resolve();
          });
        } else {
          reject();
        }
      });
    }
  };

  return { fetchLogout };
};
